import { makeUrlStateContext } from '@percept/hooks'

export type CampaignSetupUrlState = {
  referenceDate: string
}

export const CampaignSetupContext = makeUrlStateContext<CampaignSetupUrlState>()
